export const decorateDestinationHeroHtml = (text: string) => {
  const htmlWithStyle = text.replace(/<a/gi, '$& target="_blank"');

  return { __html: htmlWithStyle };
};
